import { jsx as o, jsxs as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-dialog";
import * as m from "@radix-ui/react-visually-hidden";
import e from "./dialog.module.less.js";
import { getModalPortal as N } from "../../../helpers/modal-helper.js";
const O = ({
  title: a,
  ariaDescription: l,
  children: u,
  portalContainerElementId: h,
  overlayClassName: f,
  dialogClassName: p,
  contentClassName: c,
  isOpen: v = !1,
  isModal: n = !0,
  anchor: s,
  disableOnInteractOutside: y,
  onClose: t,
  onEscapeKeyDown: j
}) => {
  const d = typeof t == "function" ? t : void 0;
  return /* @__PURE__ */ o(i.Root, { modal: n, open: v, children: /* @__PURE__ */ r(i.Portal, { container: N(h), children: [
    n && /* @__PURE__ */ o(i.Overlay, { onClick: d, className: [f, e.modalOverlay].join(" ") }),
    /* @__PURE__ */ r(
      i.Content,
      {
        "aria-description": l,
        onInteractOutside: n && !y ? d : void 0,
        onEscapeKeyDown: j,
        className: [p, e.content, s ? e[s] : e.default].join(" "),
        children: [
          a && /* @__PURE__ */ o(m.Root, { asChild: !0, children: /* @__PURE__ */ o(i.Title, { children: a }) }),
          l && /* @__PURE__ */ o(m.Root, { asChild: !0, children: /* @__PURE__ */ o(i.Description, { children: l }) }),
          /* @__PURE__ */ o("div", { className: e.closeRow, children: /* @__PURE__ */ r("button", { className: e.closeButton, onClick: t, children: [
            /* @__PURE__ */ o("span", { className: ["ui-icon-close", e.icon].join(" ") }),
            " ",
            /* @__PURE__ */ o("span", { children: "Stäng" })
          ] }) }),
          /* @__PURE__ */ o("div", { className: c || e.contentArea, children: u })
        ]
      }
    )
  ] }) });
};
export {
  O as Dialog,
  O as default
};
